<template>
  <div class="service-list layout-padding" :class="{'modalpage':page==='exhibition'}">
    <div class="btn-group-justify-end" v-if="page!=='exhibition'">
      <button @click="openServiceMenuUpdateModal" class="button is-primary">메뉴 업데이트</button>
      <button @click="$router.push('service/create')" class="button is-primary">서비스 등록</button>
    </div>

    <admin-filter
      ref="adminFilter"
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="서비스 목록"
      desc="개설된 서비스들의 현황을 조회할 수 있습니다."
    ></admin-filter>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="1800"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">

      <!-- 체크박스 -->
      <div slot="checkspot" slot-scope="props">
        <lp-check-bool
          v-if="showcaseCheckArr[props.idx]!==undefined"
          :checkedVal.sync="showcaseCheckArr[props.idx].value"></lp-check-bool>
      </div>

      <!-- 사용된 패키지 -->
      <div slot="packages" slot-scope="props">
        <span v-for="(pack, idx) in props.item.packages" :key="`pack-${idx}`">{{ packageName(pack) }}
          <span v-if="idx<props.item.packages.length-1">, </span></span>
      </div>

      <!-- 플러그인 -->
      <div slot="kor_plugins" slot-scope="props">
        <div>{{ props.item.kor_plugins[0] }} <span v-if="props.item.kor_plugins.length>1">외 {{ props.item.kor_plugins.length-1 }}건</span></div>
        <!--<span v-for="(plugin,idx) in props.item.kor_plugins" :key="`plugin-${idx}`">{{ plugin }}<span v-if="idx<props.item.kor_plugins.length-1">, </span></span>-->
      </div>

      <!-- 서비스명 -->
      <div slot="service_name" slot-scope="props">{{ props.item.service_name }}<div  style="font-size:13px">({{ props.item.key }})</div></div>
      <div slot="domain" slot-scope="props" style="line-height:1.5rem">
        <div><a :href="props.item.domain" target="_blank" style="font-size:13px">서비스 <i class="material-icons" style="font-size:17px;vertical-align: text-top">open_in_new</i></a></div>
        <div><a :href="props.item.domain+'/office/admin'" target="_blank" style="font-size:13px">백오피스 <i class="material-icons" style="font-size:17px;vertical-align: text-top">open_in_new</i></a></div>
      </div>

      <!-- 서비스 구분 -->
      <div slot="service_type" slot-scope="props">{{ serviceTypeKor(props.item.service_type) }}</div>

      <!-- 부가서비스 -->
      <div slot="addition_service" slot-scope="props">{{ additionService(props.item.service_order) }}</div>

      <!-- 서비스 해지 -->
      <div slot="terminate" slot-scope="props">
        <template v-if="props.item.service_order">
          <button class="button" style="background:#B6BECB;color:white"
                  v-if="props.item.status===9"
                  @click="clickTerminate(props.item)">서비스 해지
          </button>
        </template>
      </div>

      <!-- 종류 -->
<!--      <div slot="request_type" slot-scope="props">-->
<!--        <div v-if="props.item.request_type===0">테마</div>-->
<!--        <div v-if="props.item.request_type===1">선주문 테마</div>-->
<!--      </div>-->

      <!-- 사용자명 -->
      <div slot="service_user" slot-scope="props">
        <div>{{ props.item.service_user.name }}</div>
        <div style="font-size:13px">{{ props.item.service_user.email }}</div>
        <div style="font-size:13px">{{ props.item.service_user.phone }}</div>
      </div>

      <!-- 상태 영역 -->
      <div slot="status" slot-scope="props">
        <div class="flex">
          <!-- 상태 드롭다운 -->
          <span class="select">
            <select v-model="props.item.status" @change="props.item.saveEnable=true">
              <option v-for="item in statusOptions" :key="item.id"
                :value="item.value">{{ item.label }}</option>
            </select>
          </span>
          <!-- 소요예정시간 설정 -->
          <!--<div v-if="props.item.status>=1 && props.item.status<9">
            <input :value="props.item.remain" style="margin-left:8px;width:24px"
                 @input="e => setRemain(props.item, e)" type="number"> <span style="margin-left:4px;line-height: 32px;">소요예정</span>
          </div>-->

          <!-- 결제요청 메일 재전송 버튼 -->
          <button class="button is-danger" v-if="props.item.status===0"
                  style="margin-left: 8px;width:132px" @click.stop.prevent="sendAccountMail(props.item)">결제요청 메일 재전송</button>

          <!-- 저장 버튼 -->
          <button v-if="props.item.saveEnable"
                  class="button half is-danger"
                  style="margin-left: 8px;" @click.stop.prevent="saveItem(props.item)">저장</button>
        </div>
      </div>

      <!-- 결제 정보 -->
      <div slot="pay_type" slot-scope="props" class="flex-center">
        <div>
          <!--<div>{{ props.item.pay_type===0 ? '1회결제' : `${props.item.date_unit}개월 단위 결제` }}</div>-->
          <div v-if="props.item.service_order && props.item.service_order.next_date" style="font-size:13px">(<span style="color:#ff5722">{{ props.item.service_order.next_date.substring(5) }}</span> 결제 예정)</div>
          <div v-if="props.item.service_order && props.item.service_order.subscribe_price > 0">({{ props.item.service_order.subscribe_price | currency }})</div>
        </div>
        <!--<button class="button" style="width:96px;margin-left:20px" @click="clickAccountMethod(props.item)">결제 방법 변경</button>-->
      </div>

      <!-- 단건 결제 -->
      <div slot="pay_once" slot-scope="props" class="flex-center">
        <button class="button" style="width:80px" @click="clickOnce(props.item)">단건 결제</button>
      </div>

      <!-- 수정 / 삭제 -->
      <div slot="modify_delete" slot-scope="props">
        <button class="button half"
                @click.stop.prevent="clickModifyDelete(props.item,'update')" style="margin-right:4px">수정</button>
        <button class="button half is-danger" style="margin-left:8px"
                @click.stop.prevent="clickModifyDelete(props.item,'delete')">삭제</button>
      </div>

    </admin-table>

    <!-- 서비스 업데이트 모달 -->
    <modal name="serviceMenuUpdateModal" :adaptive="true" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <div>선택된 메뉴 {{ selectedCount }}개를 업데이트 처리하시겠습니까?</div>
        <div class="btn-group-justify-end">
          <button class="button is-light" @click="$modal.hide('serviceMenuUpdateModal')">취소</button>
          <button class="button is-primary" @click="serviceMenuUpdate">확인</button>
        </div>
      </div>
    </modal>


    <!-- 결제 방법 설정 모달 -->
    <modal name="accountModal" :adaptive="true" height="auto" class="modal-style">
      <div class="lp-modal-wrapper" v-if="selectedItem">
        <div style="height:560px">
          <div class="modal-card-title"><span style="color:#787878">{{ selectedItem.service_name }}</span> 결제 방법 설정</div>
          <admin-form-item label="정기결제금액" style="margin-top:40px" v-if="selectedItem.service_order">
            <input class="input"
                   style="width:100px;vertical-align: baseline;margin-right: 4px;"
                   v-model="selectedItem.service_order.subscribe_price"
                   @input="e => setNumber(e, 'subscribe_price', 10)"
                   type="number">원
          </admin-form-item>

          <admin-form-item label="다음 결제일" style="margin-top:20px" v-if="selectedItem.service_order">
            <admin-date-picker
              :data="selectedItem.service_order.next_date"
              @setDate="res => selectedItem.service_order.next_date = res"></admin-date-picker>

          </admin-form-item>

          <admin-form-item label="등록된 카드" style="margin-top:20px">
            <div class="flex-align">
              <div>{{ selectedItem.credit_card === '' ? '등록된 카드가 없습니다' : selectedItem.credit_card }}</div>
              <button class="button"
                      style="margin-left:12px"
                      @click="openRegBillModal">{{ selectedItem.credit_card === '' ? '카드 등록' : '카드 변경' }}</button>
            </div>
          </admin-form-item>

          <!--<admin-form-item label="카드 신규 등록 URL" style="margin-top:20px">
            <div style="font-size:13px"><input class="input-card-reg" :value="cardRegUrl" type="text" disabled> <clipboard-btn :text="cardRegUrl"></clipboard-btn></div>
          </admin-form-item>-->
        </div>
        <div class="btn-group-justify-end">
          <button class="button is-light" style="margin-left:0" @click="$modal.hide('accountModal')">취소</button>
          <button class="button is-primary" style="margin-left:6px;" @click="clickAccountDone">확인</button>
        </div>
      </div>
    </modal>
    <modal name="payOnceModal" :adaptive="true" height="auto" class="modal-style">
      <div class="lp-modal-wrapper" v-if="selectedItemOrg">
        <div class="modal-card-title"><span style="color:#787878">{{ selectedItemOrg.service_name }}</span> 단건 결제</div>
        <admin-form-item label="단건 결제 금액" style="margin-top:40px">
          <input class="input"
                 style="width:100px;vertical-align: baseline;margin-right: 4px;"
                 v-model="selectedItemOrg.price"
                 @input="e => setNumber(e, 'price', 10)"
                 type="number">원
        </admin-form-item>

        <div class="btn-group-justify-end">
          <button class="button is-light" @click="$modal.hide('payOnceModal')">취소</button>
          <button class="button is-primary" style="margin-left:6px;" @click="clickPayOnce">결제하기</button>
        </div>
      </div>
    </modal>

    <modal name="regBillModal" :adaptive="true" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <billing-form ref="form" :service="selectedItem" @done="billingDone" @close="$modal.hide('regBillModal')"></billing-form>
      </div>
    </modal>

    <service-terminate :service="selectedService" ref="serviceTerminate" v-if="selectedService"></service-terminate>

  </div>
</template>

<script>
  import LpSortDropDown from '../../../module/common/LpSortDropDown'
  import LpInputText from '../../../module/common/LpInputText'
  import LpRadio from '../../../module/common/LpRadio'
  import LpCheckBool from '../../../module/common/LpCheckBool'
  import { SweetModal } from 'sweet-modal-vue'
  import LpModal from '../../../module/common/LpModal.vue'
  import AdminFilter from "../../../module/admin/AdminFilter";
  import AdminTable from "../../../module/admin/AdminTable";
  import ListMixin from '@/mixins/ListMixin'
  import Vue from 'vue'
  import VueClipboard from 'vue-clipboard2'
  import ClipboardBtn from "@module/common/ClipboardBtn";
  import ServiceTerminate from "../../service/components/ServiceTerminate";
  import BillingForm from "../../service/components/BillForm";
  Vue.use(VueClipboard);

  export default {
    name: 'ServiceList',
    layout:'Main',
    mixins: [
      ListMixin
    ],
    props: ['page'],
    components: {
      BillingForm,
      ServiceTerminate,
      ClipboardBtn,
      AdminTable,
      AdminFilter,

      SweetModal, LpSortDropDown,
      LpInputText, LpRadio, LpModal,
      LpCheckBool
    },
    data() {
      return {
        statusOptions: [
          {value: 0, label: '이용예정'},
          {value: 5, label: '개설진행중'},
          {value: 9, label: '이용중'},
          {value: 10, label: '관리자정지'},
          {value: 99, label: '전체정지'},
          {value: 100, label: '이용중단'}
        ],
        selectedCount: 0,
        packages: [],
        selectedItem: undefined,
        selectedItemOrg: undefined,
        listPayType: [
          { label: '1회결제', value: 0 },
          { label: '정기결제', value: 1 },
        ],
        listPayMethod: [
          { label: '빌링', value: 0 },
          { label: '계좌이체', value: 1 },
        ],
        selectedService: undefined
      }
    },
    created() {
      this.init();
      this.getPackages();
    },
    computed: {
      cardRegUrl() {
        let user = this.selectedItem.service_user;
        return `https://launchpack.co.kr/bill_reg?name=${user.name}`+
          `&phone=${user.phone}&email=${user.email}&goodname=정기결제&price=${this.selectedItem.pay_price}&option_type=1`;
      }
    },
    methods: {
      init() {
        let query = {};
        if(this.isLaunchpack && this.$route.query.email) {
          query = { search_keyword: this.$route.query.email, search_type: 'email', status:9 }
        }
        this.initializing('launchpack_service', 'launchpack/service', query);

        this.$nextTick(()=>{
          if(this.isLaunchpack && this.$route.query.email) {
            let adminFilter = this.$refs.adminFilter;
            adminFilter.searchItem.search_keyword = this.$route.query.email
            adminFilter.searchItem.search_type = 'email'
            let input = document.querySelector('.lp-filter-input');
            input.value = this.$route.query.email
            let select = document.querySelector('.lp-filter-select')
            select.value = 'email';
            this.$router.replace(this.$route.path)
          }
        })
      },
      clickAccountMethod(item) {
        this.selectedItem = this.cloneItem(item);
        this.selectedItemOrg = item;
        this.$modal.show('accountModal');
      },
      clickAccountDone() {
        let item = this.cloneItem(this.selectedItem);
        if(item.pay_type === 1 && item.pay_method === 0 &&
          (!item.next_date || item.next_date === '')) {
          this.toast('다음 결제일을 설정해주세요.')
          return;
        }
        let params = {
          name: item.service_order.name,
          phone: item.service_order.phone,
          email: item.service_order.email,
          key: item.service_order.key,
          subscribe_price: item.service_order.subscribe_price,
          next_date: item.service_order.next_date ? item.service_order.next_date.substring(0, 10) + ' 14:00' : null
        };
        let url = `launchpack/service_order/${item.service_order.id}`
        this.$axios.patch(this.getUrl(url), params).then(res=>{
          if(res.status === 200) {
            this.toast('결제 정보가 변경되었습니다.');
            /*Object.keys(params).forEach(key => {
              this.selectedItemOrg[key] = params[key];
              this.selectedItemOrg.pay_price = params.price;
            });*/
            this.$modal.hide('accountModal');
            this.getData();
          }
        });
      },
      clickOnce(item) {
        let selectedItem = this.cloneItem(item);
        selectedItem.price = 0;
        this.selectedItemOrg = selectedItem;
        this.$modal.show('payOnceModal');
      },
      clickPayOnce() {
        let url = 'public/bill';
        let params = {
          // username: this.selectedItemOrg.service_user.email,
          service_id: this.selectedItemOrg.id,
          goodname: '단건결제' + `(${this.selectedItemOrg.service_name})`,
          price: parseInt(this.selectedItemOrg.price)
        }
        this.$store.commit('setLoading', true)
        this.$axios.get(url, {
          params: params
        }).then(res=>{
          if(res.status===200) {
            this.$store.commit('setLoading', false)
            this.toast('단건 결제가 완료되었습니다.');
            this.$modal.hide('payOnceModal');
          }
        }).catch(error=>{
          this.$store.commit('setLoading', false)
          if(error.response.data.message) {
            this.toast(error.response.data.message.msg)
          } else {
            this.toast('결제 실패했습니다.')
          }
        })
      },
      getPackages() {
        this.$axios.get('public/service/packages/all').then(res=> {
          this.packages = res.data;
        });
      },
      packageName(key) {
        let pack = find(this.packages, 'key', key);
        return pack ? pack.name : key === 'all' ? '전체' : '';
      },
      getDataFromServer() {
        this.getData();
      },
      openServiceMenuUpdateModal () {
        this.selectedCount = 0;
        let checked = this.getCheckedArr();
        if(checked.length===0) {
          this.toast('업데이트할 서비스를 선택하세요');
          return;
        }
        this.selectedCount = checked.length;
        this.$modal.show('serviceMenuUpdateModal');
      },
      serviceMenuUpdate () {
        this.$axios.post(this.getUrl('launchpack/service/menu/update/multiple'), {
          checked: this.getCheckedArr()
        }).then(res=> {
          if(res.status===200) {
            this.toast('선택된 메뉴 업데이트가 완료되었습니다')
          }
        })
      },
      setRemain(item, e) {
        item.remain = e.target.value;
        item.saveEnable = true;
      },
      saveItem(item) {
        this.$axios.patch(this.getUrl('launchpack/service/'+item.id), {
          status: item.status,
          remain: item.remain
        }).then(res => {
          if(res.status === 200) {
            this.toast('저장되었습니다.');
            item.saveEnable = false;
          }

        });
      },
      sendAccountMail(item) {
        this.$axios.get(this.getUrl('launchpack/service/resend_mail_account/'+item.id))
          .then(res => {
            if(res.status === 200) {
              this.toast('저장되었습니다.');
            }
          });
      },
      clickModifyDelete(item, type) {
        if(type === 'update') {
          this.$router.push(this.getPath(`launchpack/service/update?id=${item.id}`));
        }
        if(type === 'delete') {
          /*let value = {
            url: `launchpack/service/${item.id}`,
            title: '서비스를 삭제하시겠습니까? 서비스 관련 서버, 프론트엔드 코드, DB가 완전히 삭제됩니다.'
          }
          this.$store.commit('openModal', {type: 'modal-delete', value: value, width: 500});*/
          if(confirm(`${item.service_name} 서비스를 삭제하시겠습니까?`+'\n서비스 관련 서버, 프론트엔드 코드, DB가 완전히 삭제됩니다.')) {
            this.$store.commit('setLoading', true);
            this.$axios.delete(this.getUrl(`launchpack/service/${item.id}`)).then(res=>{
              if(res.status === 200) {
                this.$store.commit('setLoading', false);
                this.toast('서비스가 삭제되었습니다.');
                this.getData();
              }
            }).catch(()=>{
              this.toast('서비스 삭제 실패했습니다.');
              this.$store.commit('setLoading', false);
            });
          }
        }
      },
      setNumber(e, key, max_length) {
        if( e.target.value.length > max_length) {
          this.selectedItem[key] = parseInt(e.target.value.substr(0, max_length));
        }
        else this.selectedItem[key] = parseInt(e.target.value);
      },
      serviceTypeKor(type) {
        let names = [
          {
            name: '퀵빌더'
          },
          {
            name: '디자인마켓'
          },
          {
            name: '주문제작'
          },
          {
            name: '솔루션api'
          },
          {
            name: '플랫폼파이'
          },

        ]
        return names[type].name;
      },
      additionService(order) {
        let text = '';
        if(order) {
          if(order.hosting) text += `호스팅(${order.hosting.name})`
          if(order.care_service) text += `, 케어서비스(${order.care_service.name})`
        }
        return text;
      },
      clickTerminate(item) {
        this.selectedService = undefined;
        this.selectedService = item;
        this.$nextTick(()=>{
          this.$refs.serviceTerminate.$refs.terminateServiceModal2.open();
        })
      },
      openRegBillModal() {
        this.$modal.hide('accountModal');
        this.$modal.show('regBillModal');
      },
      billingDone() {
        if(!this.$refs.form.validate()) {
          this.toast('카드 정보를 제대로 입력해주세요.');
          return;
        }
        let url = this.getUrl(`launchpack/v1/service/${this.selectedItem.id}/reg_bill_payple`);
        let params = this.cloneItem(this.$refs.form.value);
        params.user_id = this.selectedItem.user;
        params.service_key = this.selectedItem.key;
        this.$store.commit('setLoading', true);
        this.$axios.post(url, params).then(res=>{
          this.$store.commit('setLoading', false);
          if(res.data.result==='success') {
            this.toast('카드 등록이 완료되었습니다.');
            this.$modal.hide('regBillModal');
            this.getData();
          }
          else if(res.data.message.indexOf('CDAU1002')>-1) {
            this.toast(res.data.message.replace('[CDAU1002] ',''));
          } else {
            this.toast('카드 정보가 잘못 입력되었습니다.');
            Object.keys(this.$refs.form.err).forEach((key=>{
              this.$refs.form.err[key].err = false;
            }));
            for(let item of [
              { code: '3110', key: 'card_num' },
              { code: '3115', key: 'pw' },
              { code: '3119', key: 'ex' },
              { code: '3131', key: 'birth' }
            ]) {
              if(res.data.message.indexOf(item.code)>-1) {
                this.$refs.form.err[item.key].err = true;
              }
            }
          }
        })
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  //@import '~assets/css/reset'
  @import '~assets/css/lp_main'

  .modalpage
    margin-top 50px

  a:hover
    text-decoration underline

  .input-card-reg
    padding 4px 8px
    width 80%
    margin-right 8px
</style>
<style lang="stylus">
  .service-list .admin-table td > div
    overflow unset
    -webkit-line-clamp unset


</style>
